import React, {useState} from "react"
import {Button, Dialog, DialogContent, DialogTitle, DialogActions, TextField } from "@mui/material"
import { confirmOrRejectRequest } from "../../../services/request-api"

export const Confirm = ({is_disbale, request_id, onConfirm}) => {

    const handleClick = (e) => {
        confirmOrRejectRequest({
            requestId: request_id,
            isConfirm: true
        }).then(res => {
            if (res === true && onConfirm) {
                onConfirm()
            }
        }).catch(err => {
            console.log(err)
        })
    }

    return (
        <Button disable = {is_disbale} onClick={handleClick}>Confirm</Button>
    )
}

export const Reject = ({is_disbale, request_id, user}) => {
    const [openAlert, setopenAlert] = useState(false)

    const handleClick = () => {
        setopenAlert(true)
    }
    return (
        <>
        <Button sx = {{color: "red"}} disabled = {is_disbale} onClick={handleClick}>Reject</Button>
        <AlertDialog open = {openAlert} request_id={request_id} user = {user} onClose={() => setopenAlert(false)}/>
        </>

    )
}

const  AlertDialog = ({open, request_id, onClose, user}) => {
    const [note, setnote] = useState(null)
    

    const handleNote = (event) => {
        setnote(event.target.value)
    }

    const handleReject = () => {
        confirmOrRejectRequest({
            requestId: request_id,
            isConfirm: false,
            metadata: {'note': {"user": user, "caption": note}}
        }).then(res => {
            console.log(res)
            if (res === true) {
                console.log('reject', res)
                onClose()
            }
        }).catch(err => {
            console.log(err)
        })}

    return (
      <>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Want To Reject?"}
          </DialogTitle>
          <DialogContent>
                <TextField
                required
                id="outlined-required"
                label="What's Reason?"
                onChange={handleNote}
                />
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            {note && (
            <Button onClick={handleReject} sx = {{color: "red"}}>
                Reject
            </Button>
            )}
          </DialogActions>
        </Dialog>
      </>
    );
}


export const AdvancedButton = ({is_disbale, button_label, handleSubmit}) => {
    return (
        <Button disabled={is_disbale} onClick={handleSubmit}>
            {button_label}
        </Button>
    )
}
